import { SellerOrder } from '../services/api.types';

/**
 * The delivery date to show for an order: once it is marked as delivered the
 * actual delivery timestamp wins over the date the seller planned for.
 */
export const orderDeliveryDate = (order: Pick<SellerOrder, 'deliveryDate' | 'deliveredAt'>): string | null =>
  order.deliveredAt || order.deliveryDate;
